import type { PartialTranslation } from "./index";

/** Vietnamese — see `../../vi/index.ts` for the terminology notes. */
export const settings: PartialTranslation["settings"] = {
  title: "Cài đặt",
  subtitle: "Quản lý bảo mật và tùy chọn tài khoản của bạn",
  language: {
    title: "Ngôn ngữ",
    description: "Chọn ngôn ngữ hiển thị của ứng dụng. Nội dung bạn đã lưu vẫn giữ nguyên tiếng Anh.",
    label: "Ngôn ngữ hiển thị",
    hint: "Áp dụng ngay lập tức — không cần tải lại trang.",
    changed: "Đã đặt ngôn ngữ thành {{language}}",
    learningContentNote:
      "Lyder Talk dạy tiếng Anh. Thay đổi này chỉ đổi menu, nút bấm và hướng dẫn — không đổi chủ đề hay từ vựng bạn đang học.",
  },
  account: {
    pushNotifications: "Thông báo đẩy",
    pushNotificationsDescription: "Nhận thông báo khi bài học được chia sẻ trong nhóm học của bạn",
    notEnabled: "Chưa bật",
    blockedByBrowser: "Trình duyệt đang chặn",
    enable: "Bật",
    requesting: "Đang yêu cầu…",
    unblock: "Mở khóa trong trình duyệt",
    howToEnable: "Cách bật thông báo:",
    howToEnableSteps: [
      "Nhấp vào biểu tượng ổ khóa trên thanh địa chỉ trình duyệt",
      "Tìm \"Thông báo\" trong danh sách quyền",
      "Đổi từ \"Chặn\" sang \"Cho phép\"",
      "Tải lại trang này",
    ],
    changeEmail: "Đổi email",
    changeEmailDescription: "Một email xác nhận sẽ được gửi để xác nhận thay đổi",
    currentEmail: "Email hiện tại",
    newEmail: "Email mới",
    newEmailPlaceholder: "Địa chỉ email mới",
    confirmEmail: "Xác nhận email",
    confirmEmailPlaceholder: "Xác nhận email mới",
    passwordForConfirmation: "Nhập mật khẩu để xác nhận",
    updateEmail: "Cập nhật email",
    changing: "Đang thay đổi…",
    changePassword: "Đổi mật khẩu",
    changePasswordDescription: "Giữ tài khoản an toàn với một mật khẩu mạnh",
    currentPassword: "Mật khẩu hiện tại",
    currentPasswordPlaceholder: "Nhập mật khẩu hiện tại",
    newPassword: "Mật khẩu mới",
    newPasswordPlaceholder: "Mật khẩu mới",
    confirmPassword: "Xác nhận mật khẩu",
    confirmPasswordPlaceholder: "Xác nhận mật khẩu",
    updatePassword: "Cập nhật mật khẩu",
  },
  email: {
    title: "Thông báo qua email",
    description: "Gửi đến {{email}}",
    descriptionFallback: "Chọn những email Lyder Talk gửi đến hộp thư của bạn",
    groupActivity: "Hoạt động và bình luận",
    groupActivityDescription: "Chia sẻ, thành viên tham gia, chủ đề được chọn và bình luận trên phiên học của bạn hoặc trong nhóm học",
    reviewReminders: "Nhắc ôn từ vựng",
    reviewRemindersDescription: "Một lời nhắc ngắn khi có từ đến hạn ôn, để bạn không bỏ lỡ",
    weeklyDigest: "Tóm tắt tiến độ hằng tuần",
    weeklyDigestDescription: "Một email mỗi thứ Hai với số buổi luyện, số từ đã ôn và những từ sắp đến hạn",
    allOffTitle: "Đã tắt email thông báo",
    allOffDescription: "Bạn đã hủy nhận mọi email thông báo. Email tài khoản vẫn được gửi.",
    resubscribe: "Bật lại email",
    accountMailNote: "Email đặt lại mật khẩu và xác nhận đổi email là email tài khoản và luôn được gửi.",
    saveError: "Không thể lưu tùy chọn đó",
    saveErrorDescription: "Vui lòng thử lại sau giây lát.",
    loading: "Đang tải tùy chọn email…",
    unavailable: "Hiện không thể tải tùy chọn email. Cài đặt hiện tại của bạn không thay đổi.",
  },
  profile: {
    title: "Hồ sơ",
    displayName: "Tên hiển thị",
    bio: "Giới thiệu",
    avatar: "Ảnh đại diện",
    save: "Lưu thay đổi",
    statistics: "Thống kê",
    saving: "Đang lưu…",
    sections: "Cài đặt",
    modalTitle: "Cài đặt hồ sơ",
    fallbackName: "Người học",
  },
  accountPanel: {
    title: "Tài khoản",
    blocked: "Đã chặn",
  },
  };
